const state = () => ({
  renewalMessageActive: true, // 是否要顯示 renewal message 的 popup 視窗 (規則為只要顯示一次)
});

const actions = {};

const getters = {};

const mutations = {
  /**
   * 不顯示renewal message 的 popup 視窗
   * @param {*} state
   */
  disableRenewalMessage(state) {
    state.renewalMessageActive = false;
  },
  /**
   * 允許顯示renewal message 的 popup 視窗
   * @param {*} state
   */
  enableRenewalMessage(state) {
    state.renewalMessageActive = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
